import { render, staticRenderFns } from "./PackagingManagementEB08.vue?vue&type=template&id=7dfde92e&scoped=true"
import script from "./PackagingManagementEB08.vue?vue&type=script&lang=js"
export * from "./PackagingManagementEB08.vue?vue&type=script&lang=js"
import style0 from "./PackagingManagementEB08.vue?vue&type=style&index=0&id=7dfde92e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_cache-loader@4.1.0_webpack@4.47.0__css-load_84b6d598d32b1da7294c0119ce301628/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfde92e",
  null
  
)

export default component.exports